var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionCrossIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.756 17l6.308-6.308a1.595 1.595 0 00-2.254-2.258l-6.308 6.309-6.309-6.309a1.597 1.597 0 00-2.258 2.258L15.244 17l-6.309 6.31a1.597 1.597 0 002.258 2.257l6.309-6.309 6.308 6.309a1.597 1.597 0 002.258-2.258L19.756 17z",
    fill: "#A4A4A4"
  })));
}
export default SvgSubscriptionCrossIc;